export default "__VITE_ASSET__B9lsC_cj__"